import Icon from "@expo/vector-icons/MaterialIcons";
import React from "react";
import {
  Modal,
  Pressable,
  StyleSheet,
  Text,
  View,
  useWindowDimensions,
} from "react-native";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import colors from "theme/colors";

type Props = {
  visible: boolean;
  message: string | null;
  onClose: () => void;
};

const SuccessTop = (props: Props) => {
  const viewref = React.useRef<any>();
  const { width } = useWindowDimensions();
  const animated = useSharedValue(width);

  const onClose = () => {
    animated.value = withTiming(width, { duration: 500 });
    const timeout = setTimeout(() => {
      clearTimeout(timeout);
      props.onClose();
    }, 600);
  };

  const animateStyle = useAnimatedStyle(() => {
    const translateX = animated.value;

    return {
      top: 15,
      transform: [{ translateX }],
    };
  }, [props.message]);

  React.useEffect(() => {
    if (viewref && viewref.current) {
      viewref.current?.measure(function (fx: any, fy: any, w: number) {
        animated.value = withTiming(width - (30 + w), { duration: 500 });
        const timeout = setTimeout(() => {
          clearTimeout(timeout);
          onClose();
        }, 3000);
      });
    }
  }, [viewref, props.visible]);

  if (!props.visible) {
    return null;
  }

  return (
    <Modal
      transparent
      visible={props.visible}
      animationType={"none"}
      onRequestClose={onClose}
      supportedOrientations={[
        "portrait",
        "portrait-upside-down",
        "landscape",
        "landscape-left",
        "landscape-right",
      ]}
    >
      <View style={styles.container}>
        <Pressable style={styles.flex1} onPress={onClose} />
        <Animated.View
          ref={viewref}
          style={[
            styles.v_modal,
            { transform: [{ translateX: animated.value }] },
            animateStyle,
          ]}
        >
          <View style={styles.v_check}>
            <Icon name="check" size={20} color={colors.black3} />
          </View>
          <Text style={styles.t_expired}>{props.message}</Text>
        </Animated.View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    zIndex: 2,
    backgroundColor: colors.transparent,
    ...StyleSheet.absoluteFillObject,
  },
  flex1: { flex: 1 },
  v_modal: {
    position: "absolute",
    minHeight: 50,
    paddingHorizontal: 25,
    paddingVertical: 15,
    borderRadius: 8,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.green,
  },
  v_check: {
    width: 30,
    height: 30,
    borderRadius: 30 / 2,
    backgroundColor: "white",
    alignItems: "center",
    justifyContent: "center",
  },
  t_expired: {
    marginLeft: 7,
    fontFamily: "Roboto-Medium",
    fontSize: 19,
    color: colors.white,
    textAlign: "center",
  },
  btn_okay: {
    marginLeft: 17,
    alignItems: "center",
    justifyContent: "center",
  },
});

export default SuccessTop;
